import React, {useMemo} from 'react';
import { Box } from '@mui/joy';
import { KPI } from '../../../../mtska-frontend-app-component';
import List from './List';

const Default = () => {

    return <>
        <Box className="mtksa-chart-wrapper">
            <KPI
                title="Areas"
                icon="faGauge"
                dataProviderName={'statistics/item/count/commercials/area'}
            />
        </Box>
        <List />
    </>

}

export default Default;


